import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useBrokerIntegration } from '../../../contexts/BrokerIntegrationContextCompat';


export default function AccessDetails() {
  const navigate = useNavigate();

  const { user } = useAuthContext();
  const { updateBrokerIntegration, brokerIntegrations, refreshIntegrations } = useBrokerIntegration();

  const handleApprove = async () => {
    try {
      // หา integration ของ Tastytrade ที่ล่าสุด
      const tastytradeIntegration = brokerIntegrations
        .filter(integration => integration.broker === 'tastytrade' && integration.status === 'active')
        .sort((a, b) => new Date(b.connectionDate) - new Date(a.connectionDate))[0];

      if (tastytradeIntegration) {
        // อัปเดตสถานะเป็น verified
        await updateBrokerIntegration(tastytradeIntegration.id, {
          'metadata.isVerified': true,
          'metadata.approvedAt': new Date().toISOString(),
          'status': 'active'
        });

        console.log('✅ Broker access approved and updated in Firebase');

        // ✅ Refresh broker integrations context
        try {
          await refreshIntegrations();
          console.log('✅ Broker integrations refreshed after approval');
        } catch (error) {
          console.warn('⚠️ Failed to refresh integrations, but proceeding:', error);
        }
      }
    } catch (error) {
      console.error('Error updating broker integration:', error);
    }
    navigate('/broker-success'); // ✅ ไปหน้า BrokerSuccess
  };

  const handleCancel = () => {
    navigate('/broker-connect'); // ✅ กลับไปหน้าเลือกโบรกเกอร์
  };

  return (
    <div className="flex-1 p-8">
      <h2 className="text-2xl font-bold mb-2">Access Request</h2>
      <p className="text-gray-700 mb-4">
        <span className="text-purple-600 font-semibold">JTNC</span> is requesting access to your Tradier Brokerage account with the following permissions:
      </p>

      <div className="bg-gray-100 p-4 rounded-md text-sm mb-6 space-y-1">
        <p><strong>Read</strong> – Read-only access to account info, balances, positions, orders, and watchlists</p>
        <p><strong>Write</strong> – Update and manage watchlists</p>
        <p><strong>Trade</strong> – Place, modify, and cancel orders</p>
        <p><strong>Market</strong> – Request exchange-based market data</p>
        <p><strong>Stream</strong> – Stream live market data</p>
      </div>

      <p className="text-xs text-gray-500 mb-4">
        By approving access, you acknowledge and validate that any trading activity executed via JTNC is authorized by you.
        Refer to our <a href="#" className="text-blue-600 underline">Auto Trading Disclosure</a> for more details.
      </p>

      <div className="flex gap-4">
        <button
          onClick={handleApprove}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
        >
          Approve Access
        </button>
        <button
          onClick={handleCancel}
          className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-md"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
